import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b02b846"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center py-10"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hollow-dots-spinner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "d-flex align-items-center justify-content-end mb-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 me-2" }, "Janela:", -1))
const _hoisted_7 = { class: "btn-group btn-group-sm" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "row g-4 mb-4" }
const _hoisted_10 = { class: "col-6 col-lg-3" }
const _hoisted_11 = { class: "card h-100" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "fs-2hx fw-bold" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted text-uppercase fs-8" }, "Casos ativos", -1))
const _hoisted_15 = { class: "col-6 col-lg-3" }
const _hoisted_16 = { class: "card h-100" }
const _hoisted_17 = { class: "card-body" }
const _hoisted_18 = { class: "fs-2hx fw-bold text-danger" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted text-uppercase fs-8" }, "Casos críticos", -1))
const _hoisted_20 = { class: "col-6 col-lg-3" }
const _hoisted_21 = { class: "card h-100" }
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = { class: "fs-2hx fw-bold text-warning" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted text-uppercase fs-8" }, "Atualizados 7 dias", -1))
const _hoisted_25 = { class: "col-6 col-lg-3" }
const _hoisted_26 = { class: "card h-100" }
const _hoisted_27 = { class: "card-body" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted text-uppercase fs-8 mb-2" }, "Por criticidade", -1))
const _hoisted_29 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "fs-8 text-uppercase" }
const _hoisted_32 = { class: "fs-4 fw-bold" }
const _hoisted_33 = {
  key: 0,
  class: "card mb-4"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bold" }, "Atividade — novos casos por dia")
], -1))
const _hoisted_35 = { class: "card-body pt-0" }
const _hoisted_36 = { class: "row g-4" }
const _hoisted_37 = {
  key: 0,
  class: "col-lg-6"
}
const _hoisted_38 = { class: "col-lg-6" }
const _hoisted_39 = { class: "col-lg-6" }
const _hoisted_40 = { class: "col-lg-6" }
const _hoisted_41 = { class: "col-lg-6" }
const _hoisted_42 = {
  key: 2,
  class: "alert alert-warning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_CountryMap = _resolveComponent("CountryMap")!
  const _component_TopList = _resolveComponent("TopList")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_ctx.data)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.windows, (w) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: w,
                    type: "button",
                    class: _normalizeClass(["btn", _ctx.window === w ? 'btn-warning' : 'btn-light']),
                    onClick: ($event: any) => (_ctx.setWindow(w))
                  }, _toDisplayString(w) + "d", 11, _hoisted_8))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.data.total_cases.toLocaleString()), 1),
                    _hoisted_14
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.data.critical_count.toLocaleString()), 1),
                    _hoisted_19
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.data.updated_last_7d.toLocaleString()), 1),
                    _hoisted_24
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.criticityTiles, (lvl) => {
                        return (_openBlock(), _createElementBlock("a", {
                          key: lvl.key,
                          href: "#",
                          class: "text-decoration-none",
                          onClick: _withModifiers(($event: any) => (_ctx.filter('criticity', lvl.key, false)), ["prevent"])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(`badge badge-light-${lvl.color} d-flex flex-column align-items-center px-3 py-2`)
                          }, [
                            _createElementVNode("span", _hoisted_31, _toDisplayString(lvl.key), 1),
                            _createElementVNode("span", _hoisted_32, _toDisplayString(lvl.count), 1)
                          ], 2)
                        ], 8, _hoisted_30))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]),
            (_ctx.activitySeries[0].data.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_apexchart, {
                      type: "area",
                      height: "220",
                      options: _ctx.activityOptions,
                      series: _ctx.activitySeries
                    }, null, 8, ["options", "series"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_36, [
              (_ctx.data.countries?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createVNode(_component_CountryMap, {
                      countries: _ctx.data.countries,
                      onFilter: _cache[0] || (_cache[0] = (code) => _ctx.filter('countries_code', code))
                    }, null, 8, ["countries"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_TopList, {
                  title: "Top atores de ameaça",
                  icon: "bi-people",
                  color: "danger",
                  field: "threat_actors",
                  buckets: _ctx.data.top_threat_actors,
                  onFilter: _ctx.filter
                }, null, 8, ["buckets", "onFilter"])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_component_TopList, {
                  title: "Top CVEs",
                  icon: "bi-bug",
                  color: "primary",
                  field: "cves",
                  buckets: _ctx.data.top_cves,
                  onFilter: _ctx.filter
                }, null, 8, ["buckets", "onFilter"])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_TopList, {
                  title: "Top setores afetados",
                  icon: "bi-buildings",
                  color: "info",
                  field: "victim_sectors",
                  buckets: _ctx.data.top_victim_sectors,
                  onFilter: _ctx.filter
                }, null, 8, ["buckets", "onFilter"])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createVNode(_component_TopList, {
                  title: "Top malwares",
                  icon: "bi-virus",
                  color: "warning",
                  field: "malware_families",
                  buckets: _ctx.data.top_malware,
                  onFilter: _ctx.filter
                }, null, 8, ["buckets", "onFilter"])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_42, "Não foi possível carregar o panorama."))
  ]))
}